import React from 'react'
import PropTypes from 'prop-types'
import MaterialUIRadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import Radio from '@material-ui/core/Radio'

export default function RadioGroup(props) {
  const {
    options,
    value,
    name,
    label,
    onChange,
    row,
  } = props

  const handleChange = (evt) => {
    onChange(evt)
  }

  const renderRadio = (item) => (
    <FormControlLabel
      key={item.id}
      value={item.id}
      control={<Radio />}
      label={item.name}
    />
  )

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        {label}
      </FormLabel>

      <MaterialUIRadioGroup
        row={row}
        aria-label={label}
        name={name}
        value={value}
        onChange={handleChange}
      >
        {options.map(renderRadio)}
      </MaterialUIRadioGroup>
    </FormControl>
  )
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  row: PropTypes.bool,
}

RadioGroup.defaultProps = {
  row: false,
}
